/**
 * 정기결제 결과 페이지
 * FSD: pages/subscription-checkout-result
 */

import React from 'react';
import { BillingKeyResult } from '@/features/subscription/checkout/ui/BillingKeyResult';

const SubscriptionCheckoutResultPage: React.FC = () => {
  return <BillingKeyResult />;
};

export default SubscriptionCheckoutResultPage;
